import React, { createContext, useState } from 'react'
import { contractAddress,contractABI } from './contractData';

export const Context = createContext()

export const Provider = ({ children }) => {
  const [account, setAccount] = useState("");
//   const [signer, setSigner] = useState();
  const [contract, setContract] = useState();
  const [web3, setWeb3] = useState();
  const [correctNetwork] = useState(5);
  const [currentNetwork, setCurrentNetwork] = useState("");
  const [owner] = useState("0x2868571CDdDA47E85b060B73EfA131f860CE4511");
  

  const value = {
    account,
    setAccount,
    // signer,
    // setSigner,
    contract,
    setContract,
    web3,
    setWeb3,
    contractAddress,
    contractABI,
    owner,
    setCurrentNetwork,
    correctNetwork,
    currentNetwork
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}